'use strict';

import Alerts from 'lib/alerts';
import template from 'commons/templates/CustomerSupportForm.ejs';
import FormView from 'commons/views/Form';
import moment from 'moment';
import validate from 'validate.js';
import loader from 'helpers/loader';
import Log from 'lib/log';

const log = Log('common/customer-support-form');

const questionSubjects = [
  'How do I apply for leave?',
  'How do I know my leave request is approved?',
  'How do I know my leave request is rejected?',
  'How do I know my leave balance?',
  'How do I change my login email?',
  'How do I change my login password?',
  'How do I change my personal details?',
  'How to check my bank details?',
  'What should I do when I forgot my login password?',
  'Where can I find my previous payslips?',
];

validate.extend(validate.validators.datetime, {
    parse: function(value) {
        return +moment.utc(value, 'DD/MM/YYYY');
    },

    format: function(value) {
        const format = 'DD/MM/YYYY';
        return moment.utc(value).format(format);
    }
});

module.exports = FormView.extend({

    subViews: null,

    events: function() {
        return Object.assign({}, FormView.prototype.events(), {
            'click .send':   'send'
        });
    },

    initialize: function(options) {
        this.events = Object.assign({},
            FormView.prototype.events || {},
            this.events
        );

        this.options = Object.assign({
            template: template,
            templateExtra: {}
        }, options || {});

        this.options.templateExtra = Object.assign(this.options.templateExtra, {
            questionSubjects
        });

        return FormView.prototype.initialize.apply(this, [this.options]);
    },

    render: function() {
        FormView.prototype.render.apply(this, arguments);
        return this;
    },

    showSendEmailErrors: function(errors) {
        if (!_.isEmpty(errors)) {
            this.invalid(null, errors);
        } else {
            Alerts.show('error', {
                title: 'Unable to send the message',
                text: 'Error occured while sending your message. Sorry.',
            });
        }
    },

    send: function(ev) {
        var $button    = this.$(ev.currentTarget);
        var stopLoader;

        ev.preventDefault();

        if ($button.closest('.js-ext', this.el).length > 0) {
            return;
        }

        stopLoader = loader.startFullScreen($button);

        this.trigger('save');

        this.sendEmail()
            .then(() => stopLoader())
            .then(() => this.sent())
            .then(() => this.render())
            .catch(errors => this.showSendEmailErrors(errors))
            .finally(() => stopLoader());
    },

    sendEmail: function() {
        const questionSubject = this.$('select[name=questionSubject]').val();
        const desc = this.$('[name=desc]').val();
        const validationError = this.validateSendEmail({
            questionSubject
        });

        if (!_.isEmpty(validationError)) {
            return Promise.reject(validationError);
        }

        return this.model.sendCustomerSupportEmail(
            questionSubject, desc
        ).catch(errors => {
            log.error(errors);
            return Promise.reject();
        });
    },

    validateSendEmail: function(values) {
        const errs = validate(values, {
            questionSubject: {presence: true}
        });

        return _.isEmpty(errs) ? false : {errors: errs};
    },

    sent: function() {
        return new Promise(resolve => {
            Alerts.show('success', {
                title: 'Message sent!',
                text: 'Your question has been sent successfully!',
                callback: () => resolve(true)
            });
        });
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/CustomerSupportForm.js